<template>

<div class="imei-list table-hook fadeInRight">
    <div class="title-box">
        <span class="m-title">IMEI更新列表</span>
        <el-form inline class="hook right themed-form search-form" style="line-height: 40px;">
			<el-form-item label="IMEIS:">
			    <el-input v-model="form.imeis"></el-input>
			</el-form-item>
            <el-form-item label="IMEI:">
                <el-input v-model="form.imei"></el-input>
            </el-form-item>
			<el-form-item label="ICCID:">
			    <el-input v-model="form.iccid"></el-input>
			</el-form-item>
            <el-form-item label="随机码:">
                <el-input v-model="form.chipid"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-search" class="themed-button" @click="searchData">搜索查询</el-button>
            </el-form-item>
			<el-form-item>
				<el-button type="primary" icon="el-icon-plus" class="themed-button" @click="onAdd">单个新增</el-button>
			</el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-plus" class="themed-button" @click="importAdd">批量新增</el-button>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="el-icon-minus" class="themed-button" @click="importDelete">批量删除</el-button>
            </el-form-item>
        </el-form>
    </div>
    <div class="content-box">
        <el-table ref="table"  :data="tableData" stripe border :max-height="maxTableHeight">
            <el-table-column label="IMEI" prop="newImei" show-overflow-tooltip></el-table-column>
			<el-table-column label="ICCID" prop="iccid" show-overflow-tooltip></el-table-column>
            <el-table-column label="随机码" prop="chipid" show-overflow-tooltip></el-table-column>
            <el-table-column label="创建时间" prop="createTime" show-overflow-tooltip></el-table-column>
            <el-table-column label="操作" width="150px">
                <template slot-scope="scope">
                    <el-button type="info" class="themed-button" @click="deleteById(scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
    <div class="pagination">
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[5, 10, 15, 50,100,1000]"
        :page-size="pageSize"
        background
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
        </el-pagination>
    </div>
	<el-dialog :title="dialogTitle" :visible.sync="dialogBox" v-if="dialogBox">
	    <add-imei v-if="dialogContent == 'add-imei'" @close="onClose" @close-dialog='onClose'></add-imei>
	    <add-imeis v-if="dialogContent == 'add-imeis'" @close="onClose" @close-dialog='onClose'></add-imeis>
	    <delete-imei v-if="dialogContent == 'delect-imeis'" @close="onClose" @close-dialog='onClose'></delete-imei>
	</el-dialog>
	
</div>

</template>

<script type="text/ecmascript-6">
    import {imeiUpdateList, imeiUpdateSave, batchImportSync, deleteImeiById, batchDeleteSync} from '@/api/meCardBindManagement/imeiUpdataList.js'
    import {messageBox,confirmBox } from '@/utils/common.js'
    import resize from '@/mixins/resize.js'

	import AddImei from '@/views/meCardBindManagement/imeiUpdataList/addImei'
	import AddImeis from '@/views/meCardBindManagement/imeiUpdataList/addImeis'
	import DeleteImei from '@/views/meCardBindManagement/imeiUpdataList/deleteImei'
	
    export default {
        // name:'imeiUpdataList',
        mixins:[resize],
        data(){
            return {
                form:{
					imeis:'',
                    imei:'',
                    iccid:'',
                    chipid:''
                },
                tableData:[],
                pageSize:15,
                currentPage:1,
                total:0,

                dialogBox:false,
                dialogTitle:'',
                dialogContent:""
            }
        },
        mounted(){
            this._imeiUpdateList()
        },
        methods:{
			onClose(){
				this.dialogBox = false
				this._imeiUpdateList()
			},
			onAdd(){
			    this.dialogTitle = '新增IMEI'
				this.dialogContent = "add-imei"
			    this.dialogBox = true
			},
            importAdd(){
                this.dialogTitle = '批量新增IMEI'
				this.dialogContent = "add-imeis"
                this.dialogBox = true
            },
            importDelete(){
                this.dialogTitle = '批量删除IMEI'
				this.dialogContent = "delect-imeis"
                this.dialogBox = true
            },
            deleteById(data){
                let msg = "IMEI：" + data.newImei + "</br>" + "ICCID：" + data.iccid + "</br>" + "随机码：" + data.chipid + "</br></br>是否确认删除?"
                confirmBox(this, msg, '操作提示',()=>{
                    deleteImeiById(Object.assign({id: data.id}, this.form)).then((res)=>{
                        messageBox(this,'删除成功')
                        this._imeiUpdateList()
                    })
                })
            },

            searchData(){
                this._imeiUpdateList()
            },
            handleSizeChange(val) {
                this.pageSize = val
                this._imeiUpdateList()
            },
            handleCurrentChange(val) {
                this.currentPage = val
                this._imeiUpdateList()
            },
            _imeiUpdateList(){
                let params = {}
                params.pageSize = this.pageSize
                params.pageNo = this.currentPage
                imeiUpdateList(Object.assign(params, this.form)).then((res)=>{
					console.log(res)
					res = res.page || {}
                    this.total = res.total
                    this.currentPage = res.pageNo
                    this.pageSize = res.pageSize
                    this.tableData = res.rows
                })
            }
        },
		components:{
			AddImei,
		    AddImeis,
		    DeleteImei
		}
    }
</script>

